exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Bar-module__wrapper___OWzTF{border-radius:4px;display:grid;padding:.25em;background:#fff;width:calc(100vw - 240px);max-width:1000px;grid-column:1;grid-row:1}.Bar-module__wrapper___OWzTF input{background:#bdccd4;border:none;text-align:center;font-size:18px}", ""]);

// exports
exports.locals = {
	"wrapper": "Bar-module__wrapper___OWzTF"
};